import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M2.27734 16.6848C2.27734 14.9539 4.61593 13.5508 7.50073 13.5508C10.3855 13.5508 12.7241 14.9539 12.7241 16.6848",
      stroke: "#9296A0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.3496 11.1895C15.766 11.1895 17.7249 12.3648 17.7249 13.8146",
      stroke: "#9296A0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.50122 10.4165C9.2321 10.4165 10.6353 9.01335 10.6353 7.28247C10.6353 5.55159 9.2321 4.14844 7.50122 4.14844C5.77034 4.14844 4.36719 5.55159 4.36719 7.28247C4.36719 9.01335 5.77034 10.4165 7.50122 10.4165Z",
      stroke: "#9296A0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1),
    _createElementVNode("path", {
      d: "M13.3482 8.56484C14.798 8.56484 15.9733 7.3895 15.9733 5.93964C15.9733 4.48979 14.798 3.31445 13.3482 3.31445C12.8421 3.31445 12.3696 3.45761 11.9688 3.70564",
      stroke: "#9296A0",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ]))]))
}
export default { render: render }